import { Flex, keyframes, styled } from '@nilohealth/core-ui'
import { MdArrowDownward } from 'react-icons/md'

export const BignumberWrapper = styled('div', {
  display: 'flex',
  backgroundColor: '$neutralHighPure',
  justifySelf: 'start',
  width: 'fit-content',
  height: 'fit-content',
  padding: '$xxxsmall',
  borderRadius: '$medium',
  variants: {
    withBorder: {
      true: {
        border: '1px solid $neutralHighMedium',
        borderRadius: '$medium',
      },
    },
  },
  defaultVariants: { withBorder: false },
  // TODO: substitute these hardcoded values by core-ui breakpoints values
  '@sm': { width: '100%' },
  '@md': { width: '100%', maxWidth: '194px' },
  '@lg': { width: '100%', maxWidth: '194px' },
})

export const BignumberContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: 'calc($huge - $xxsmall)', // this value is to compensate the 32px of padding x and y on BignumberWrapper
  '> div': { width: '100%' },
})

const arrowAnimation = keyframes({
  '0%': { transform: 'translateX(0px)' },
  '50%': { transform: 'translateX(8px)' },
  '100%': { transform: 'translateX(0px)' },
})

export const BigNumberTooltipContainer = styled(Flex, {
  position: 'absolute',
  top: '$xxxsmall',
  right: '$micro',
})

export const BignumberCard = styled('div', {
  position: 'relative',
  display: 'flex',
  backgroundColor: '$neutralHighPure',
  border: 0,
  height: 'calc($huge + $nano)',
  padding: '$xxxsmall',
  borderRadius: '$medium',
  // TODO: substitute these hardcoded values by core-ui breakpoints values
  '@sm': { width: '100%' },
  '@md': { width: '100%', maxWidth: '194px' },
  '@lg': { width: '100%', maxWidth: '194px' },
  variants: {
    hasDetails: {
      true: {
        '&:hover:not(:disabled)': {
          '.details-tag svg': {
            animationName: arrowAnimation,
            animationDelay: '.25s',
            animationDuration: '.75s',
          },
        },
      },
    },
    disabled: {
      false: {
        '&:has(:not(.bignumber-tooltip-container:hover)):hover': {
          backgroundColor: '$neutralHighLight',
          cursor: 'pointer',
        },
        '&:focus, &:active': {
          outline: 0,
          boxShadow: '0 0 0 $borderWidths$thick $colors$primaryMedium',
        },
      },
    },
    mode: {
      category: { border: '1px solid $neutralHighLight' },
      home: {},
      indicator: {},
    },
  },
  defaultVariants: {
    mode: 'home',
    hasDetails: false,
    disabled: false,
  },
})

export const ArrowIcon = styled(MdArrowDownward, {
  size: '$xxxsmall',
  minWidth: '$xxxsmall',
  variants: {
    isPositive: {
      true: {
        color: '$successPure',
        transform: 'rotate(180deg)',
      },
      false: {
        color: '$errorMedium',
        transform: 'rotate(0deg)',
      },
    }
  }
})
